import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { CopyPasteItem, TabKeys } from "../types";

type State = {
  updates: number;
  bulkUpdates: number;
  updatedSlides: string[];
  activeTab: TabKeys | null;
  copiedItem?: CopyPasteItem;
  /** Scene canvas zoom factor (1 = 100%). Visual only. */
  zoom: number;
};

type Action = {
  addTemplateUpdate: () => void;
  addBulkTemplateUpdate: () => void;
  resetTemplateUpdates: () => void;
  resetBulkTemplateUpdates: () => void;
  setActiveTab: (tab: TabKeys) => void;
  addUpdatedSlide: (slideId: string) => void;
  resetUpdatedSlides: () => void;
  setCopiedItem: (item?: CopyPasteItem) => void;
  setZoom: (zoom: number) => void;
};

export type TemplatesStatusStore = State & Action;

const initialState: State = {
  updates: 0,
  bulkUpdates: 0,
  updatedSlides: [],
  activeTab: TabKeys.script,
  zoom: 1,
};

export const useTemplatesStatusStore = create<TemplatesStatusStore>()(
  devtools(
    immer((set) => ({
      ...initialState,
      addTemplateUpdate: () => {
        set(
          (state) => {
            state.updates += 1;
          },
          undefined,
          "addTemplateUpdate"
        );
      },
      addBulkTemplateUpdate: () => {
        set(
          (state) => {
            state.bulkUpdates += 1;
          },
          undefined,
          "addBulkTemplateUpdate"
        );
      },
      resetTemplateUpdates: () => {
        set(
          (state) => {
            state.updates = 0;
          },
          undefined,
          "resetTemplateUpdates"
        );
      },
      resetBulkTemplateUpdates: () => {
        set(
          (state) => {
            state.bulkUpdates = 0;
          },
          undefined,
          "resetBulkTemplateUpdates"
        );
      },
      addUpdatedSlide: (slideId) => {
        set(
          (state) => {
            state.updatedSlides.push(slideId);
          },
          undefined,
          "addUpdatedSlide"
        );
      },
      resetUpdatedSlides: () => {
        set(
          (state) => {
            state.updatedSlides = [];
          },
          undefined,
          "resetUpdatedSlides"
        );
      },
      setActiveTab: (tab) => {
        set(
          (state) => {
            state.activeTab = tab;
          },
          undefined,
          "setActiveTab"
        );
      },
      setCopiedItem: (item) =>
        set(
          (state) => {
            state.copiedItem = item;
          },
          undefined,
          "setCopiedItem"
        ),
      setZoom: (zoom) =>
        set(
          (state) => {
            state.zoom = zoom;
          },
          undefined,
          "setZoom"
        ),
    })),
    { name: "TemplatesStatusStore" }
  )
);
